import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export default function ProtectedRoute({ children }) {
    const { user, checking } = useAuth();
    const location = useLocation();

    if (checking || user === null) {
        return (
            <div className="min-h-screen flex items-center justify-center bg-[#030712]">
                <div className="text-slate-400 font-mono-alt text-sm animate-pulse">Authenticating…</div>
            </div>
        );
    }

    if (!user) {
        return <Navigate to="/admin/login" state={{ from: location }} replace />;
    }

    return children;
}
